import React from 'react';

import Usps from './Usps';

export default function ProductSkeleton({ additionalData }: { additionalData: { usps?: string } }) {
  return (
    <>
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="w-full xs:w-1/2 2xl:w-1/3 p-2 lg:px-3.75 lg:py-3">
          <div className="group/card-product relative text-gray-950 animate-pulse">
            <div className="relative mb-2 md:mb-4 rounded-lg bg-gray-300 overflow-hidden">
              <div className="aspect-[4/5] bg-gray-300" />
            </div>
            <div className="lg:flex lg:gap-3 lg:justify-between px-1">
              <div className="bg-gray-300 h-8 w-3/4 mb-2 rounded-sm" />
              <div className="lg:text-right w-1/4">
                <div className="bg-gray-300 h-8 rounded-sm" />
              </div>
            </div>
          </div>
        </div>
      ))}
      {additionalData.usps && (<Usps swiperSlides={additionalData.usps} />)}
      {Array.from({ length: 6 }, (_, index) => (
        <div key={index} className="w-full xs:w-1/2 2xl:w-1/3 p-2 lg:px-3.75 lg:py-3">
          <div className="group/card-product relative text-gray-950 animate-pulse">
            <div className="relative mb-2 md:mb-4 rounded-lg bg-gray-300 overflow-hidden">
              <div className="aspect-[4/5] bg-gray-300" />
            </div>
            <div className="lg:flex lg:gap-3 lg:justify-between px-1">
              <div className="bg-gray-300 h-8 w-3/4 mb-2 rounded-sm" />
              <div className="lg:text-right w-1/4">
                <div className="bg-gray-300 h-8 rounded-sm" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
